// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#bio::placeholder{font-size:14px;color:#626264;font-family:\"HelveticaNeueCyr-Light\",\"Helvetica\",sans-serif}.MuiOutlinedInput-multiline.MuiOutlinedInput-marginDense{padding:10px}\n", ""]);
// Exports
module.exports = exports;
